import { Component } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TransportExternalInformationsGroup } from '../transport-external-informations.model';

@Component({
  selector: 'app-transport-external-informations',
  templateUrl: './transport-external-informations.component.html',
  styleUrls: ['./transport-external-informations.component.scss']
})
export class TransportExternalInformationsComponent extends AbstractWidgetComponent {

  transportId: number;

  transportExternalInformationsGroups = new Array<TransportExternalInformationsGroup>();

  constructor(public translationService: TranslationService, private appServerAPI: AppServerAPI) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    try {
      if (contextChange.key === 'selected-transport') {
        const selectedTransport = this.dashboardContext.context.get('selected-transport');
        if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
          this.transportId = selectedTransport.id;
          this.loadExternalInformations();
        }
      }

      if (contextChange.key === 'transport-changed') {
        if (this.transportId != null) {
          this.loadExternalInformations();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  onSetElementAndContext() {
    const transport = this.dashboardContext.context.get('selected-transport');
    if (transport != null && transport.id != null) {
      this.transportId = transport.id;
      this.loadExternalInformations();
    }
  }

  private loadExternalInformations() {
    const identity = new Identity();
    identity.id = this.transportId;
    this.appServerAPI.execute<TransportExternalInformationsGroup[]>('/client/control/transport/details/transport-externalinformations', identity).subscribe(
      response => {
        const groups = new Array<TransportExternalInformationsGroup>();
        if (response != null) {
          for (const elm of response) {
            groups.push(new TransportExternalInformationsGroup(elm));
          }
        }
        this.transportExternalInformationsGroups.push(...groups);
      }
    );
  }


}
